import React, { useState } from "react";
import { Form, Button, Container, Row, Col, Card, Alert, Spinner } from "react-bootstrap";
import { useNavigate } from "react-router-dom";
import emailjs from "emailjs-com";

const Feedback = () => {
  const [formData, setFormData] = useState({
    name: "",
    phone: "",
    address: "",
    isSHG: "",
    groupName: "",
    groupLocation: "",
    feedback: "",
    rating: "",
  });

  const [submitted, setSubmitted] = useState(false);
  const [loading, setLoading] = useState(false);
  const [errorMsg, setErrorMsg] = useState("");
  const navigate = useNavigate();

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    setErrorMsg("");

    if (!/^\d{10}$/.test(formData.phone)) {
      setErrorMsg("Please enter a valid 10-digit phone number.");
      return;
    }

    const templateParams = {
      name: formData.name,
      phone: formData.phone,
      address: formData.address,
      isSHG: formData.isSHG,
      groupName: formData.groupName || "N/A",
      groupLocation: formData.groupLocation || "N/A",
      feedback: formData.feedback,
      rating: formData.rating,
    };

    setLoading(true);

    emailjs
      .send(
        process.env.REACT_APP_EMAILJS_SERVICE_ID,
        process.env.REACT_APP_EMAILJS_TEMPLATE_ID,
        templateParams,
        process.env.REACT_APP_EMAILJS_PUBLIC_KEY
      )
      .then(
        (response) => {
          console.log("Email sent successfully!", response.status, response.text);
          setLoading(false);
          setSubmitted(true);
          setFormData({
            name: "",
            phone: "",
            address: "",
            isSHG: "",
            groupName: "",
            groupLocation: "",
            feedback: "",
            rating: "",
          });
          setTimeout(() => navigate("/"), 2000);
        },
        (err) => {
          console.error("Email send error", err);
          setLoading(false);
          setErrorMsg("Failed to send feedback. Please try again.");
        }
      );
  };

  return (
    <Container className="py-5" style={{padding:"75px"}}>
      <Row className="justify-content-center">
        <Col md={8}>
          <Card className="p-4 shadow-lg border-0">
            <h2 className="text-center mb-4">Feedback Form</h2>

            {submitted ? (
              <Alert variant="success" className="text-center">
                🎉 Thank you for your feedback!
              </Alert>
            ) : (
              <>
                {errorMsg && <Alert variant="danger">{errorMsg}</Alert>}

                <Form onSubmit={handleSubmit}>
                  <Form.Group className="mb-3">
                    <Form.Label>Name</Form.Label>
                    <Form.Control
                      type="text"
                      name="name"
                      value={formData.name}
                      onChange={handleChange}
                      required
                    />
                  </Form.Group>

                  <Form.Group className="mb-3">
                    <Form.Label>Phone Number</Form.Label>
                    <Form.Control
                      type="tel"
                      name="phone"
                      value={formData.phone}
                      onChange={handleChange}
                      maxLength="10"
                      required
                    />
                  </Form.Group>

                  <Form.Group className="mb-3">
                    <Form.Label>Address</Form.Label>
                    <Form.Control
                      as="textarea"
                      rows={2}
                      name="address"
                      value={formData.address}
                      onChange={handleChange}
                      required
                    />
                  </Form.Group>

                  <Form.Group className="mb-3">
                    <Form.Label>Are you SHG Member?</Form.Label>
                    <div>
                      <Form.Check
                        inline
                        label="Yes"
                        name="isSHG"
                        value="yes"
                        type="radio"
                        checked={formData.isSHG === "yes"}
                        onChange={handleChange}
                      />
                      <Form.Check
                        inline
                        label="No"
                        name="isSHG"
                        value="no"
                        type="radio"
                        checked={formData.isSHG === "no"}
                        onChange={handleChange}
                      />
                    </div>
                  </Form.Group>

                  {formData.isSHG === "yes" && (
                    <>
                      <Form.Group className="mb-3">
                        <Form.Label>Group Name</Form.Label>
                        <Form.Control
                          type="text"
                          name="groupName"
                          value={formData.groupName}
                          onChange={handleChange}
                          required
                        />
                      </Form.Group>

                      <Form.Group className="mb-3">
                        <Form.Label>Group Location</Form.Label>
                        <Form.Control
                          type="text"
                          name="groupLocation"
                          value={formData.groupLocation}
                          onChange={handleChange}
                          required
                        />
                      </Form.Group>
                    </>
                  )}

                  <Form.Group className="mb-3">
                    <Form.Label>Feedback (Max 200 Characters)</Form.Label>
                    <Form.Control
                      as="textarea"
                      rows={3}
                      name="feedback"
                      maxLength="200"
                      value={formData.feedback}
                      onChange={handleChange}
                      required
                    />
                    <small className="text-muted">{formData.feedback.length}/200</small>
                  </Form.Group>

                  <Form.Group className="mb-3">
                    <Form.Label>Rating</Form.Label>
                    <Form.Select
                      name="rating"
                      value={formData.rating}
                      onChange={handleChange}
                      required
                    >
                      <option value="">Select Rating</option>
                      <option value="1">⭐</option>
                      <option value="2">⭐⭐</option>
                      <option value="3">⭐⭐⭐</option>
                      <option value="4">⭐⭐⭐⭐</option>
                      <option value="5">⭐⭐⭐⭐⭐</option>
                    </Form.Select>
                  </Form.Group>

                  <Button variant="primary" type="submit" className="w-100" disabled={loading}>
                    {loading ? (
                      <>
                        <Spinner animation="border" size="sm" role="status" className="me-2" />
                        Sending...
                      </>
                    ) : (
                      "Submit Feedback"
                    )}
                  </Button>
                </Form>
              </>
            )}
          </Card>
        </Col>
      </Row>
    </Container>
  );
};

export default Feedback;
